import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'element-plus/theme-chalk/index.css'
import element_plus from 'element-plus'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { createStore } from 'vuex'
import './assets/sass/style.scss'
import './assets/sass/app.scss'
import VCalendar from 'v-calendar'
import 'v-calendar/dist/style.css'
import ja from 'element-plus/dist/locale/ja'
import VueCookies from 'vue3-cookies'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import * as icons from './components/icons/modules'

const app = createApp(App)
const store = createStore({
  state () {
    return {
      cowManageFilterParam: {
        save: false
      },
      barnManageFilterParam: {
        save: false
      },
      calfCowFilterParam: {
        save: false
      },
      cowFilterParam: {
        save: false
      },
      cowMenuSelect: '',
      userAdmin: false,
      userType: -1,
      filterParams: {
        save: false,
        filter_params: []
      }
    }
  },
  mutations: {
    setCowMenuSelect (state, val) {
      state.cowMenuSelect = val
    },
    setUserAdmin (state, val) {
      state.userAdmin = val
    },
    setUserType (state, val) {
      state.userType = val
    },
    setFilterParams(state, val) {
      state.filterParams = val
    },
    setCowManageFilterParam(state, val) {
      state.cowManageFilterParam = val
    },
    setBarnManageFilterParam(state, val) {
      state.barnManageFilterParam = val
    },
    setCalfCowFilterParam(state, val) {
      state.calfCowFilterParam = val
    },
    setCowFilterParam(state, val) {
      state.cowFilterParam = val
    }
  }
})

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

for (const component in icons) {
  app.component(component, icons[component])
}

app.use(router)
app.use(element_plus, { locale: ja })
app.use(VueAxios, axios)
app.use(store)
app.use(VCalendar)
app.use(VueViewer)
app.use(VueCookies, {
  expireTimes: "1d",
  path: "/",
  domain: "",
  secure: true,
  sameSite: "None"
})
app.mount('#app')
